import { css } from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import type { WebsiteTranslatorSettings } from '../../types';

const widthMapping = {
  small: 5,
  medium: 5,
  large: 6
};

const lineHeightMapping = {
  small: 16,
  medium: 18,
  large: 22
};

export function slash({
  _widgetSize,
  _textColor
}: {
  _widgetSize: WebsiteTranslatorSettings['widgetSize'];
  _textColor: WebsiteTranslatorSettings['textColor'];
}) {
  const width = widthMapping[_widgetSize];
  const lineHeight = lineHeightMapping[_widgetSize];

  return css`
    &::before {
      content: '/';
      font-size: inherit;
      line-height: ${lineHeight}px;
      width: ${width}px;
      ${_textColor && `color: ${getColorWithAlpha(_textColor, 0.5)};`}
    }

    &:first-child::before {
      display: none;
    }
  `;
}
